import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M677.647059 0L677.647059 564.705882 903.529412 564.705882 903.529412 865.807059 225.769412 865.807059 225.769412 1355.29412 0 1355.29412 0 1920 564.705882 1920 564.705882 1355.29412 338.710588 1355.29412 338.710588 978.861176 903.529412 978.861176 903.529412 1355.29412 677.647059 1355.29412 677.647059 1920 1242.24 1920 1242.24 1355.29412 1016.47059 1355.29412 1016.47059 978.861176 1581.17647 978.861176 1581.17647 1355.29412 1355.18118 1355.29412 1355.18118 1920 1920 1920 1920 1355.29412 1694.11765 1355.29412 1694.11765 865.807059 1016.47059 865.807059 1016.47059 564.705882 1242.24 564.705882 1242.24 0z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSubaccountsSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconSubaccountsSolid, _Component);

  var _super = _createSuper(IconSubaccountsSolid);

  function IconSubaccountsSolid() {
    _classCallCheck(this, IconSubaccountsSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconSubaccountsSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSubaccounts",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconSubaccountsSolid.displayName = "IconSubaccountsSolid";
  return IconSubaccountsSolid;
}(Component);

IconSubaccountsSolid.glyphName = 'subaccounts';
IconSubaccountsSolid.variant = 'Solid';
IconSubaccountsSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSubaccountsSolid;
export { IconSubaccountsSolid };